import React from "react";
import {DashboardCell} from "./base/DashboardCell";
import {
    CurrencyConversionInfo,
    CURRENCY_CONVERSION_VARIANT_BUSINESS_UNIT
} from "../../../elements/CurrencyConversionInfo";

/**
 * Celda de la columna Moneda de la línea de control.
 *
 * Igual que una celda de valor simple, pero cuando alguna de sus cuentas publicitarias opera
 * en otra moneda agrega el aviso de que los importes están convertidos.
 */
export class DashboardCurrencyCell extends DashboardCell {
    render() {
        return (
            <td className={`single-data ${this.processingCssClasses()}`}>
                {this.props.value}
                <CurrencyConversionInfo conversions={this.props.conversions}
                                        variant={CURRENCY_CONVERSION_VARIANT_BUSINESS_UNIT}/>
            </td>
        );
    }
}
